import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_STORAGE_KEY = "gd_auth_token";

/**
 * Read the persisted JWT (if any) from localStorage.
 * Used to attach an `Authorization: Bearer …` header so the app works
 * even on browsers (e.g. Safari with strict ITP / "Prevent cross-site
 * tracking") that silently drop httpOnly auth cookies.
 */
export function getStoredToken() {
  try {
    return window.localStorage?.getItem(TOKEN_STORAGE_KEY) || null;
  } catch (err) {
    // localStorage disabled (private mode / strict cookies). Cookie
    // fallback still applies so this is non-fatal.
    if (process.env.NODE_ENV === "development") {
      console.debug("[api] could not read auth token from storage:", err);
    }
    return null;
  }
}

export function setStoredToken(token) {
  try {
    if (token) window.localStorage?.setItem(TOKEN_STORAGE_KEY, token);
    else window.localStorage?.removeItem(TOKEN_STORAGE_KEY);
  } catch (err) {
    if (process.env.NODE_ENV === "development") {
      console.debug("[api] could not persist auth token:", err);
    }
  }
}

// We send cookies AND a Bearer token (when present) with every request, so
// the backend can authenticate either way. The Bearer header is the rescue
// path for Safari users whose cookie gets dropped by ITP.
const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
